module.exports = __webpack_public_path__ + "img/en2.cc0199d9.png";